import {
  Box,
  Grid,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC,} from "react";
import PersonIcon from '@mui/icons-material/Person';

export interface ErrorMessageProps {
  message: string;
  icon?: boolean,
  justifyContent? : string
}


export const ErrorMessage: FC<ErrorMessageProps> = ({message, icon = false, justifyContent ='flex-start'}) => {

  return (
    <Grid container justifyContent="center" alignItems='center'>
      <Box
        sx={{
          width:{xs:'90%', sm:'70%', md:'50%', lg:'38%'},
          // maxWidth:'100%',
          height: 80,
          padding:" 1rem 1rem 1rem 1rem",
          position:'fixed',
          zIndex:4,
          bottom:71,
          backgroundColor: '#FF5252',
          borderRadius: '4px',
          alignItems:'center',
          display: 'flex',
          flexDirection : 'row',
          justifyContent: {justifyContent},
        }}
      >
      {
        icon && (
          <PersonIcon fontSize="small" sx={{color: "white"} }/>
        )
      }
      
      <Typography sx={{ml : 2, fontSize:'16px', fontWeight:'400', color:'white', textAlign:'left' }}>
        {message}
        </Typography>
      </Box>
    </Grid>
  );
}; 
